import React, { createContext } from 'react';

// Context to store the auth token passed from mobile app webview
const AuthTokenContext = createContext({
  token: null,
  setToken: () => {},
  isAuthChecked: false,
  setIsAuthChecked: () => {},
  authError: null,
  setAuthError: () => {}
});

export default AuthTokenContext;
